import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { ArrowNext } from '../index';
import { withStyles, MenuItem } from '@material-ui/core';
import styles from './styles';

const OpenHour = ({ classes, t }) => {
  return (
    <React.Fragment>
      <MenuItem className={classes.wrapper}>
        <span className={classes.logo__container}>
          <span className={classes.open__logo}>{t('mp-information.label.open')}</span>
        </span>
        <span className={classes.title}>{t('mp-information.label.open-hours')}</span>
        <ArrowNext classess={classes.arrow} />
      </MenuItem>
    </React.Fragment>
  );
};

OpenHour.propTypes = {
  classes: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
};

export default withStyles(styles)(withTranslation()(OpenHour));
